import { create } from 'zustand';

import { IPendingCredential, IPendingCredentialStore } from './types';

export const usePendingCredentialStore = create<IPendingCredentialStore>(
	(set) => ({
		pendingCredential: { providerId: '', token: '', email: '' },
		setPendingCredential: (pendingCredential: IPendingCredential) =>
			set({ pendingCredential }),
		resetPendingCredential: () =>
			set({ pendingCredential: { providerId: '', token: '', email: '' } }),
	})
);
